import { Injectable } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import * as Sentry from '@sentry/angular';
import { GoogleLogEvents } from '../constants/log';
import { Logger } from '../model/device/log.model';
import {
  PurchaseGoogleProducts,
  PurchaseRequest,
} from '../model/http/google.model';
import { decamelizeKeys } from 'humps';
import { BannerAnalitycs } from '../model/local/banner.model';

@Injectable({
  providedIn: 'root',
})
export class GoogleLoggerStrategy implements Logger {
  constructor(private analyticsService: AngularFireAnalytics) {}

  exception(error: string, isFatal: boolean): void {
    this.safeTrack(
      () =>
        this.analyticsService.logEvent(GoogleLogEvents.exception, {
          exDescription: error?.substring(0, 149),
          exFatal: isFatal,
        }),
      'analytics-exception'
    );
  }
  addToCar(): void {}
  purchase(purchaseData: PurchaseRequest): void {
    const googlePurchaseObject = new PurchaseGoogleProducts();
    googlePurchaseObject.value = purchaseData.total;
    googlePurchaseObject.coupon = purchaseData.coupon;
    googlePurchaseObject.affiliation = purchaseData.affiliation;
    googlePurchaseObject.currency = purchaseData.currency;
    googlePurchaseObject.tax = purchaseData.totalTax;
    googlePurchaseObject.shipping = purchaseData.shippingCost;
    googlePurchaseObject.transactionId = purchaseData.transactionId;
    googlePurchaseObject.items = purchaseData.items.map((product) => {
      return {
        discount: product.discount,
        itemId: product.itemCode,
        itemName: product.itemCode,
        price: product.price,
        quantity: product.quantity,
      };
    });
    const decamelizeobject = decamelizeKeys(googlePurchaseObject);
    this.safeTrack(
      () =>
        this.analyticsService.logEvent(
          GoogleLogEvents.purchase,
          decamelizeobject
        ),
      'analytics-purchase'
    );
  }
  screenView(): void {
    this.safeTrack(
      () => this.analyticsService.logEvent(GoogleLogEvents.screenView),
      'analytics-screen-view'
    );
  }

  bannerClick(data: BannerAnalitycs): void {
    this.safeTrack(
      () =>
        this.analyticsService.logEvent(GoogleLogEvents.bannerClick, {
          banner: data.name,
          route: data.pageRedirection
        }),
      'analytics-banner-click'
    );
  }
  configId(id: string): void {
    this.safeTrack(
      () => this.analyticsService.setUserId(id),
      'analytics-config-id'
    );
  }

  private safeTrack(action: () => unknown, feature: string): void {
    try {
      const result = action();
      if (result && typeof (result as Promise<unknown>).catch === 'function') {
        (result as Promise<unknown>).catch((error) => this.reportTrackingError(error, feature));
      }
    } catch (error) {
      this.reportTrackingError(error, feature);
    }
  }

  private reportTrackingError(error: unknown, feature: string): void {
    Sentry.captureException(error, { tags: { feature } });
  }
}
